import Service from './Service';

export default class SearchTerms extends Service {

  listTop({ search_type }) {
    return this.axiosInstance.get(`/search_terms/top${search_type ? '?search_type=' + search_type : ''}`);
  }

}